import React from "react";

import CloseIcon from "@mui/icons-material/Close";

import { ButtonBase } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import { BlocksFormHook } from "hooks/form/useBlocksForm";

import { BlockEnum } from "types/enums";

import { blockEnumMap } from "utils/blockEnumMap";

function BlockImage({
    setOpenedSelectBlock,
    onAddBlockClick,
    item,
}: {
    onAddBlockClick: (
        blockName: BlockEnum,
        setOpenedSelectBlock: React.Dispatch<React.SetStateAction<boolean>>,
    ) => void;
    setOpenedSelectBlock: React.Dispatch<React.SetStateAction<boolean>>;
    item: BlockEnum;
}) {
    return (
        <GridRow className={"module-image"} justifyContent={"center"}>
            <GridItem className={"image-text-container col-xs-12-12"}>
                <ButtonBase onClick={() => onAddBlockClick(item, setOpenedSelectBlock)}>
                    <img
                        src={blockEnumMap[item].img}
                        alt={blockEnumMap[item].title}
                        className={"actual-image"}
                    />
                </ButtonBase>
            </GridItem>

            <GridItem className={"module-name image-text-container col-xs-12-12"}>
                <p>{blockEnumMap[item].title}</p>
            </GridItem>
        </GridRow>
    );
}

function BlockSelect({ blocksFormHook }: { blocksFormHook: BlocksFormHook }) {
    const { blocksArray, onAddBlockClick } = blocksFormHook;

    const [openedSelectBlock, setOpenedSelectBlock] = React.useState<boolean>(false);

    const onSelectBlockClick = React.useCallback(() => setOpenedSelectBlock((prev) => !prev), []);

    return (
        <GridItem>
            {!openedSelectBlock ? (
                <GridColumn className={"col-xs-12-12 module-selector-closed"}>
                    <ButtonBase onClick={onSelectBlockClick} className={"button-new-module"}>
                        <GridColumn>
                            <GridRow justifyContent={"center"}>
                                <GridItem>
                                    <h2>AGGIUNGI NUOVO BLOCCO</h2>
                                </GridItem>
                            </GridRow>
                        </GridColumn>
                    </ButtonBase>
                </GridColumn>
            ) : (
                <GridColumn className={"col-xs-12-12 module-selector-opened"}>
                    <GridItem>
                        <GridRow alignItems={"center"} justifyContent={"left"}>
                            <GridItem className={"close-button"}>
                                <ButtonBase onClick={onSelectBlockClick}>
                                    <CloseIcon />
                                </ButtonBase>
                            </GridItem>

                            {blocksArray.map((item) => {
                                return (
                                    <>
                                        {(item === BlockEnum.SectionOne ||
                                            item === BlockEnum.SectionOneImageCentered ||
                                            item === BlockEnum.SectionVideo) && (
                                            <GridColumn>
                                                <GridItem>
                                                    <GridRow justifyContent={"center"}>
                                                        <GridItem>
                                                            <h2
                                                                style={{
                                                                    fontSize: "1.5rem",
                                                                    padding: "1.5rem",
                                                                }}
                                                            >
                                                                {item === BlockEnum.SectionOne &&
                                                                    "Testi e Immagini"}

                                                                {item ===
                                                                    BlockEnum.SectionOneImageCentered &&
                                                                    "Solo Immagini"}
                                                                {item === BlockEnum.SectionVideo &&
                                                                    "Video"}
                                                            </h2>
                                                        </GridItem>
                                                    </GridRow>
                                                </GridItem>
                                            </GridColumn>
                                        )}

                                        <GridItem className={"col-xs-12-3"}>
                                            <BlockImage
                                                setOpenedSelectBlock={setOpenedSelectBlock}
                                                onAddBlockClick={onAddBlockClick}
                                                item={item}
                                            />
                                        </GridItem>
                                    </>
                                );
                            })}
                        </GridRow>
                    </GridItem>
                </GridColumn>
            )}
        </GridItem>
    );
}

export default BlockSelect;
